import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { FormField } from "../shared/FormField";
import { apiClient, getApiErrorMessage } from "../../lib/apiClient";

export function DeactivateDialog({ open, onOpenChange, subscriptionId, onDone }) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  const handleConfirm = async () => {
    setSaving(true);
    try {
      await apiClient.post(`/subscriptions/${subscriptionId}/deactivate`, { deactivation_reason: reason || null });
      toast.success("Subscription deactivated");
      onDone();
    } catch (error) {
      toast.error(getApiErrorMessage(error, "Could not deactivate this subscription."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="subscription-deactivate-dialog">
        <DialogHeader>
          <DialogTitle>Deactivate this subscription?</DialogTitle>
          <DialogDescription>
            The customer will stop being scheduled for deliveries. This can be reversed with Reactivate.
          </DialogDescription>
        </DialogHeader>
        <FormField label="Reason (optional)" testId="subscription-deactivate-reason">
          <Textarea
            placeholder="e.g. non-payment, stopped responding, moved city..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            data-testid="subscription-deactivate-reason-input"
          />
        </FormField>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)} data-testid="subscription-deactivate-cancel-button">
            Cancel
          </Button>
          <Button variant="danger" disabled={saving} onClick={handleConfirm} data-testid="subscription-deactivate-confirm-button">
            {saving ? "Working..." : "Deactivate Subscription"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
